import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { shopApi } from "./shopApi";

export const useMetaPixelConfig = () => {
  const queryClient = useQueryClient();

  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.META_PIXEL_CONFIG(),
    queryFn: () => shopApi.fetchMetaPixelConfig(),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.META_PIXEL_CONFIG(),
    });
  };

  return {
    isLoading,
    isFetching,
    metaPixelConfig: data?.data,
    invalidate,
  };
};
